import { render, staticRenderFns } from "./PopUpEliminar.vue?vue&type=template&id=645774e4"
import script from "./PopUpEliminar.vue?vue&type=script&lang=js"
export * from "./PopUpEliminar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports